export enum Position {
  top = 'top',
  bottom = 'bottom',
  left = 'left',
  right = 'right'
}
